import { Author } from '../api/Author';
import apiService from '../api/apiService';
import tokenService from '../utils/tokenService';

export const INVALID_SESSION_ERROR =
  'Session invalide ou expirée. Veuillez vous reconnecter.';

export interface AuthSessionResult {
  author: Author | null;
  token: string | null;
  error: string | null;
}

const createEmptySessionResult = (error: string | null): AuthSessionResult => ({
  author: null,
  token: null,
  error,
});

const getAuthFailureMessage = (error: unknown): string => {
  if (error instanceof Error) {
    return `Une erreur est survenue lors de l'authentification: ${error.message}`;
  }

  return "Une erreur est survenue lors de l'authentification: Erreur inconnue";
};

export const resolveAuthSession = async (): Promise<AuthSessionResult> => {
  try {
    const storedToken = await tokenService.getToken();

    if (!storedToken) {
      return createEmptySessionResult(null);
    }

    const fetchedAuthor = await apiService.validateTokenAndGetAuthor(storedToken);

    if (fetchedAuthor) {
      return {
        author: fetchedAuthor,
        token: storedToken,
        error: null,
      };
    }

    await tokenService.clearToken();
    return createEmptySessionResult(INVALID_SESSION_ERROR);
  } catch (error: unknown) {
    await tokenService.clearToken();
    return createEmptySessionResult(getAuthFailureMessage(error));
  }
};

export const clearAuthSession = async (): Promise<void> => {
  await tokenService.clearToken();
};
